"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.processValue = exports.getInitialValue = void 0;
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// Previously value was just an array of selected options
// Then we decided to save additional information such as userText
// That's why we need this function to convert array to object to not have breaking changes
var processValue = function processValue(value) {
  if (_typeof(value) === 'object' && value.selected) {
    return _objectSpread({
      selectedLabels: {},
      userTexts: {}
    }, value);
  }
  return {
    selected: value || [],
    selectedLabels: {},
    userTexts: {}
  };
};
exports.processValue = processValue;
var getInitialValue = function getInitialValue() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultValueVariables = arguments.length > 1 ? arguments[1] : undefined;
  var _settings$options = settings.options,
    options = _settings$options === void 0 ? [] : _settings$options,
    optionTypes = settings.optionTypes,
    defaultValueVariable = settings.defaultValueVariable;
  if (defaultValueVariable) {
    if (defaultValueVariables) {
      var defaultValue = (0, _get2["default"])(defaultValueVariables, defaultValueVariable);
      if (!defaultValue) {
        console.error("There is no variable \"".concat(defaultValueVariable, "\""));
      } else if (!(0, _isArray2["default"])(defaultValue)) {
        console.error("The value of \"".concat(defaultValueVariable, "\" variable should be an array"));
      } else {
        return defaultValue;
      }
    }
  } else {
    var result = [];
    options.forEach(function (option) {
      if (option.type === 'static') {
        var optionType = (0, _find2["default"])(optionTypes[option.type], {
          id: option.id
        });
        if (optionType.isDefault) {
          result.push(option.id);
        }
      }
    });
    if (result.length > 0) {
      return result;
    }
  }
  return undefined;
};
exports.getInitialValue = getInitialValue;
var validate = function validate(value, settings) {
  var error;

  // Just to not to break old format
  if (Array.isArray(value)) {
    value = {
      selected: value
    };
  }
  var visualType = settings.visualType,
    singleAnswerRequired = settings.singleAnswerRequired,
    singleOrMultiple = settings.singleOrMultiple,
    requiredErrorMessage = settings.requiredErrorMessage,
    multiAnswerMin = settings.multiAnswerMin,
    multiAnswerMax = settings.multiAnswerMax,
    minAnswersErrorMessage = settings.minAnswersErrorMessage,
    maxAnswersErrorMessage = settings.maxAnswersErrorMessage;
  if (visualType === 'radio' || visualType === 'dropdown' || visualType === 'image' && singleOrMultiple === 'single' || visualType === 'button' && singleOrMultiple === 'single') {
    if (singleAnswerRequired) {
      if (!value || value.selected.length === 0) {
        return requiredErrorMessage;
      }
    }
  }
  if (visualType === 'checkbox' || visualType === 'button' && singleOrMultiple === 'multiple' || visualType === 'image' && singleOrMultiple === 'multiple') {
    if (multiAnswerMin) {
      if (!value || value.selected.length < +multiAnswerMin) {
        return (0, _cccisdSurveyCommon.replaceVars)(minAnswersErrorMessage, {
          min: multiAnswerMin
        });
      }
    }
    if (multiAnswerMax) {
      if (value && value.selected.length > +multiAnswerMax) {
        return (0, _cccisdSurveyCommon.replaceVars)(maxAnswersErrorMessage, {
          max: multiAnswerMax
        });
      }
    }
  }
  return error;
};
exports.validate = validate;